var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartLightFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8202 7.34228C12.8732 7.02149 14.775 7.78453 16.0103 9.17914C17.2375 7.83336 19.1221 7.02242 21.1753 7.34154C23.3301 7.65136 25.1579 9.25823 25.7703 11.393C26.5314 13.9125 25.5217 15.9681 24.0816 17.4222C23.7764 17.7982 22.8296 18.7753 21.7558 19.8649C20.6205 21.0168 19.2857 22.3516 18.2529 23.3844L18.252 23.3854C17.0323 24.6051 15.0346 24.6051 13.8149 23.3854L13.7642 23.3346C11.72 21.2905 8.4985 18.069 7.927 17.43C6.56698 15.9949 5.46001 13.9338 6.23162 11.3875L6.23774 11.3683C6.91711 9.33012 8.65658 7.72847 10.8045 7.34491L10.8202 7.34228Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartLightFilled);
export default __webpack_public_path__ + "static/media/icon_heart_light_filled.814bd5b1.svg";
export { ForwardRef as ReactComponent };